/* Bewegung. Drei Dinge, bewusst getrennt:
   1. Fortschrittsbalken, Kopfleiste und Handy-Leiste haengen am Scrollen.
   2. Abschnitte blenden beim Hereinscrollen ein.
   3. Die Zahl im Zahlenband zaehlt einmal hoch.

   Verstecken passiert NUR hier, nie im CSS: ohne JavaScript bleibt die Seite
   vollstaendig lesbar. Kontaktdaten und Impressum haengen an keinem Skript. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Scrollgebundenes ------------------------------------------- */
  var prog = document.querySelector('.prog');
  var head = document.querySelector('.head');
  var bar = document.querySelector('.bar');
  var acts = document.querySelector('.hero .acts');
  var hero = document.querySelector('.hero');
  var queued = false;

  function onScroll() {
    queued = false;
    var y = window.scrollY || window.pageYOffset || 0;
    if (prog) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      prog.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0) + ')';
    }
    if (head) head.classList.toggle('is-stuck', y > 24);
    // Die Handy-Leiste taucht auf, sobald die Schaltflaechen im Hero nicht mehr
    // zu sehen sind. Sonst stuenden zweimal dieselben Knoepfe auf dem Schirm.
    // Gemessen wird die echte Lage der Knopfreihe, nicht die Hero-Hoehe: ueber
    // dem Hero liegt inzwischen die Bannerleiste, eine feste Rechnung waere falsch.
    if (bar && acts) {
      var k = acts.getBoundingClientRect();
      bar.classList.toggle('tuck', k.bottom > 0 && k.top < window.innerHeight);
    }
    // Hero-Foto wandert langsamer als die Seite. Nur solange der Hero ueberhaupt
    // im Bild ist, danach waere es reine Rechnerei ins Leere.
    if (hero && !reduce && y < hero.offsetHeight) {
      hero.style.setProperty('--par', (y * 0.18).toFixed(1) + 'px');
    }
  }
  function queue() {
    if (!queued) { queued = true; requestAnimationFrame(onScroll); }
  }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  onScroll();

  /* ---- 3. Zaehlwerk --------------------------------------------------- */
  function countUp(el) {
    var to = parseInt(el.getAttribute('data-to'), 10);
    if (!to || el.dataset.done) return;
    el.dataset.done = '1';
    var target = el.textContent, t0 = null, dur = 1400;
    el.textContent = '0';
    requestAnimationFrame(function step(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min((ts - t0) / dur, 1);
      el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))).toLocaleString('de-DE');
      if (k < 1) requestAnimationFrame(step);
      else el.textContent = target;   // am Ende die exakte Schreibweise zurueck
    });
  }

  /* ---- 4. Bannerleiste ------------------------------------------------
     Die Leiste braucht ihren Inhalt zweimal, damit sie nahtlos weiterlaeuft.
     Geklont wird hier statt im HTML: dieselbe data-URI ein zweites Mal in die
     Datei zu schreiben kostet ein Viertelmegabyte fuer null zusaetzliche Pixel.
     Die Kopien sind fuer Vorlesegeraete unsichtbar, sonst liest die Leiste
     jedes Banner doppelt vor. Ohne dieses Skript bleibt die Reihe stehen und
     laesst sich seitlich schieben. */
  var reel = document.querySelector('[data-reel]');
  var track = reel && reel.firstElementChild;
  if (track && !reduce) {
    Array.prototype.slice.call(track.children).forEach(function (li) {
      var kopie = li.cloneNode(true);
      kopie.setAttribute('aria-hidden', 'true');
      var bild = kopie.querySelector('img');
      if (bild) { bild.alt = ''; }
      track.appendChild(kopie);
    });
    reel.classList.add('is-ready');
  }

  /* ---- 6. Erreichbarkeit in Echtzeit -----------------------------------
     Der Grundtext im HTML nennt die Bueroezeiten und stimmt immer. Hier wird
     daraus die konkrete Aussage fuer genau jetzt, gerechnet nach Berliner
     Zeit statt nach der Uhr des Besuchers. Faellt Intl aus, bleibt der
     Grundtext stehen: lieber allgemein als falsch. */
  var statusEl = document.querySelector('[data-status]');
  if (statusEl) {
    try {
      var teile = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit',
        hour12: false, hourCycle: 'h23'
      }).formatToParts(new Date());
      var tag = '', stunde = NaN;
      teile.forEach(function (t) {
        if (t.type === 'weekday') { tag = t.value.slice(0, 2); }
        if (t.type === 'hour') { stunde = parseInt(t.value, 10); }
      });
      var werktag = ['Mo', 'Di', 'Mi', 'Do', 'Fr'].indexOf(tag) > -1;
      var txt = statusEl.querySelector('.txt');
      if (!isNaN(stunde)) {
        if (werktag && stunde >= 8 && stunde < 18) {
          statusEl.classList.add('offen');
          txt.textContent = 'Jetzt persönlich erreichbar. Rufen Sie einfach durch.';
        } else if (werktag && stunde < 8) {
          statusEl.classList.add('zu');
          txt.textContent = 'Ab 08:00 Uhr sind wir persönlich da. WhatsApp und E-Mail gehen jederzeit.';
        } else {
          statusEl.classList.add('zu');
          txt.textContent = 'Gerade außerhalb der Bürozeiten. WhatsApp und E-Mail gehen jederzeit, wir melden uns am nächsten Werktag.';
        }
      }
    } catch (e) { /* Grundtext bleibt stehen */ }
  }

  /* ---- 7. Lichtschein unter dem Zeiger ---------------------------------
     Nur auf Geraeten mit echtem Zeiger. Am Finger gibt es kein Schweben,
     da waere der Schein nur ein Aufblitzen beim Antippen. */
  if (!reduce && window.matchMedia('(hover:hover)').matches) {
    document.querySelectorAll('.dark .cards .card').forEach(function (karte) {
      karte.addEventListener('pointermove', function (e) {
        var r = karte.getBoundingClientRect();
        karte.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        karte.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  /* ---- 5. Rechtstexte ueber die Fusszeile aufklappen -------------------
     Ein Sprung auf #agb soll die Klappe auch oeffnen, nicht nur hinscrollen.
     Nicht jeder Browser macht das von sich aus. */
  function klappeAuf() {
    var id = location.hash;
    if (!id || id.length < 2) { return; }
    var ziel;
    try { ziel = document.querySelector(id); } catch (e) { return; }
    if (ziel && ziel.tagName === 'DETAILS') {
      ziel.open = true;
      ziel.scrollIntoView({ block: 'start' });
    }
  }
  window.addEventListener('hashchange', klappeAuf);
  klappeAuf();

  /* ---- 2. Einblenden -------------------------------------------------- */
  var groups = document.querySelectorAll('.rise,[data-stagger]');
  if (!groups.length || !('IntersectionObserver' in window) || reduce) return;

  groups.forEach(function (g) {
    g.classList.add('pre');
    if (g.hasAttribute('data-stagger')) {
      Array.prototype.forEach.call(g.children, function (kind, i) {
        kind.style.setProperty('--d', (i * 70) + 'ms');
      });
    }
  });

  var fired = false;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      fired = true;
      e.target.classList.remove('pre');
      Array.prototype.forEach.call(e.target.querySelectorAll('.cnt'), countUp);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  groups.forEach(function (g) { io.observe(g); });

  // Notausgang nur fuer den Fall, dass der Observer ueberhaupt nie ausloest.
  // Loeste er schon einmal aus, arbeitet er, dann bleibt das Scroll-Einblenden.
  setTimeout(function () {
    if (!fired) groups.forEach(function (g) { g.classList.remove('pre'); });
  }, 3000);
})();